const Endpoints = {
  PROJECTS: 'projects',
  PROJECT_BY_ID: (projectId: string) => `projects/${projectId}`,
  PROJECT_TODOS: (projectId: string) => `projects/${projectId}/todos`,
  PROJECT_MEMBERS: (projectId: string) => `projects/${projectId}/members`,
  PROJECT_MEMBER_BY_ID: (projectId: string, memberId: string) =>
    `projects/${encodeURIComponent(projectId)}/members/${encodeURIComponent(memberId)}`,
  PROJECT_ACCEPT_INVITATION: (projectId: string) =>
    `projects/${encodeURIComponent(projectId)}/members/accept`,
  PROJECT_DECLINE_INVITATION: (projectId: string) =>
    `projects/${encodeURIComponent(projectId)}/members/decline`,
  PROJECT_LEAVE: (projectId: string) =>
    `projects/${encodeURIComponent(projectId)}/members/leave`,
  PROJECT_PENDING_INVITATIONS: 'projects/invitations/pending',
  PROJECT_NOTES: (projectId: string) => `projects/${projectId}/notes`,
  PROJECT_NOTE_BY_ID: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}`,
  PROJECT_NOTE_DOC: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/doc`,
  PROJECT_NOTE_REALTIME_AUTH: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/realtime-auth`,
  PROJECT_NOTE_IMAGES: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/images`,
  PROJECT_NOTE_AUDIO: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/audio`,
  PROJECT_NOTE_PDFS: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/pdfs`,
  PROJECT_NOTE_COMMENTS: (projectId: string, noteId: string) =>
    `projects/${projectId}/notes/${noteId}/comments`,
  PROJECT_NOTE_COMMENT_BY_ID: (
    projectId: string,
    noteId: string,
    commentId: string
  ) => `projects/${projectId}/notes/${noteId}/comments/${commentId}`,
  PROJECT_NOTE_EMBED_TASKS: (projectId: string) =>
    `projects/${projectId}/note-embeds/tasks`,
  USER_SETTINGS: '/user-settings',
  USER_DETAILS: '/user/details',
  USER_DETAILS_CURRENT_ACTIVITY_PROPS: '/user/details/current-activity-props',
  USER_TIMEZONE: '/user/timezone',
  SUBSCRIPTION_STRIPE_PRODUCTS: '/subscription/stripe/products',
  COMPLETED_ACTIVITY: '/completed-activity',
  COMPLETED_ACTIVITY_CONSISTENCY_STATS: '/completed-activity/consistency-stats',
  COMPLETED_FOCUS_BLOCKS: '/completed-focus-blocks',
  COMPLETED_ACTIVITY_SEQUENCE_STATS:
    '/completed-activity-sequence/{activity_sequence_id}/stats?days_number=30&timezone=UTC',
  ROUTINE_PROGRESS: '/completed-activity-sequence/routine-progress',
  FORCE_COMPLETE_CURRENT_SEQUENCE:
    '/completed-activity-sequence/{activity_sequence_id}/force-complete-current-sequence',
  WEEKLY_FOCUS_BLOCK_SUMMARY: 'user/weekly-focus-block-summary',
  WEEKLY_COMPLETED_ACTIVITY_SUMMARY: 'user/weekly-completed-activity-summary',
  USER_INSTALLED_HABIT_PACKS: '/habit-packs/user-packs',
  HABIT_PACKS: '/habit-packs',
  INSTALL_HABIT_PACK: '/habit-packs/{pack_id}/install',
  INSTALL_HABIT_PACK_AS_DEFAULT_SETTINGS:
    '/habit-packs/default?pack_id={pack_id}',
  UNINSTALL_HABIT_PACK: '/habit-packs/{pack_id}/uninstall',
  GET_USER_CREATED_PACKS: '/habit-packs?user_id={user_id}',
  ACCESS_HABIT_PACK_BY_ID: '/habit-packs/{pack_id}',
  USER_LIST: '/user/user-list',
  USER_INFO_AND_FOCUS_MODES: '/user',
  USER_SIGN_UP_TEMPLATE: '/user/sign-up-template',
  VIDEO_METADATA: '/video-metadata',
  UPSERT_FOCUS_MODE_TEMPLATE: '/focus-mode-template',
  GET_USER_CREATED_FOCUS_TEMPLATES: '/focus-mode-template?author_id={user_id}',
  GET_MARKETPLACE_APPROVED_FOCUS_TEMPLATES:
    '/focus-mode-template?marketplace_approval_status=true',
  GET_USER_INSTALLED_FOCUS_TEMPLATES: '/focus-mode-template/user-installed',
  DELETE_FOCUS_TEMPLATE: '/focus-mode-template/{template_id}',
  INSTALL_FOCUS_TEMPLATE: '/focus-mode-template/{template_id}/install',
  UNINSTALL_FOCUS_TEMPLATE: '/focus-mode?id={focus_mode_id}',
  GET_FOCUS_TEMPLATE_BY_ID: '/focus-mode-template/{template_id}',
  ACTIVITY_LIBRARY: '/activity-library',
  USER_METADATA: '/user/metadata',
  DELETE_ACTIVITY_IMAGE: '/activity/images?file_path={file_path}',
  ACTIVITY_IMAGES: (activityId: string) => `/activity/${activityId}/images`,
  ACTIVITY_IMAGE_GENERATE_UPLOAD_URL: (activityId: string) =>
    `/activity/${activityId}/images/generate-upload-url`,
  DEVICE: '/device',
  USER_ONBOARDING_STATS: '/user/stats/onboarding',
  MOTIVATIONAL_SUMMARY: '/user/motivational-summary',
  CHAT: '/user/chat',
  USER_CONSENT: '/user/consent',
  USER_CONSENT_STATUS: '/user/consent-status',
  ACTIVITY: '/activity',
  STRIPE: {
    CREATE_CHECKOUT_SESSION: 'subscription/stripe/create-checkout-session',
    CREATE_PORTAL_SESSION: 'subscription/stripe/create-portal-session',
    CANCEL_SUBSCRIPTION_SESSION:
      'subscription/stripe/cancel-subscription-session'
  },
  USER_SUBSCRIPTION: '/user/subscription',
  USER_ACCESS_REQUEST: 'user/access-request',
  COMPLETED_ACTIVITY_SKIP: '/completed-activity/skip',
  USER_STATS_LEADER_BOARD: 'user-stats/leaderboard',
  COMPLETED_ACTIVITY_DAY_SUMMARY: 'completed-activity/day-summary',
  USER_LONG_TERM_GOALS: 'user/long-term-goals',
  USER_WEEKLY_FOCUS_BLOCK_SUMMARY: 'user/weekly-focus-block-summary',
  UPDATE_FOCUS_BLOCK_SUMMARY: 'user/weekly-focus-block-summary/:id',
  DELETE_FOCUS_BLOCK_SUMMARY: 'user/weekly-focus-block-summary/:id',
  CREATE_FOCUS_BLOCK_SUMMARY: 'user/weekly-focus-block-summary',
  USER_USERNAME: 'user/username',
  USER_DATA: '/user-data',
  USER: 'user',
  SAVED_WEBSITE: 'saved-website',
  SAVED_WEBSITE_DELETE: 'saved-website/delete',
  TO_DO: 'to-do',
  TASK_COMMENTS: (taskId: string) => `to-do/${taskId}/comments`,
  TASK_COMMENT_BY_ID: (taskId: string, commentId: string) =>
    `to-do/${taskId}/comments/${commentId}`,
  COMMENT_REACTIONS: (taskId: string, commentId: string) =>
    `to-do/${taskId}/comments/${commentId}/reactions`,
  COMMENT_REACTION_BY_ID: (
    taskId: string,
    commentId: string,
    reactionId: string
  ) => `to-do/${taskId}/comments/${commentId}/reactions/${reactionId}`,
  TASK_REACTIONS: (taskId: string) => `to-do/${taskId}/reactions`,
  TASK_REACTION_BY_ID: (taskId: string, reactionId: string) =>
    `to-do/${taskId}/reactions/${reactionId}`,
  TASK_ATTACHMENTS: (taskId: string) => `to-do/${taskId}/attachments`,
  TASK_ATTACHMENT_UPLOAD_URL: (taskId: string) =>
    `to-do/${taskId}/attachments/generate-upload-url`,
  TASK_ATTACHMENT_BY_ID: (taskId: string, attachmentId: string) =>
    `to-do/${taskId}/attachments/${attachmentId}`,
  TASK_ATTACHMENT_DOWNLOAD_URL: (taskId: string, attachmentId: string) =>
    `to-do/${taskId}/attachments/${attachmentId}/download-url`,
  COMMENT_ATTACHMENTS: (taskId: string, commentId: string) =>
    `to-do/${taskId}/comments/${commentId}/attachments`,
  COMMENT_ATTACHMENT_UPLOAD_URL: (taskId: string, commentId: string) =>
    `to-do/${taskId}/comments/${commentId}/attachments/generate-upload-url`,
  COMMENT_ATTACHMENT_BY_ID: (commentId: string, attachmentId: string) =>
    `comments/${commentId}/attachments/${attachmentId}`,
  COMMENT_ATTACHMENT_DOWNLOAD_URL: (commentId: string, attachmentId: string) =>
    `comments/${commentId}/attachments/${attachmentId}/download-url`,
  TO_DO_BY_IDS: 'to-do/by-ids',
  TO_DO_BY_ID: (id: string) => `to-do/${id}`,
  FOCUS_MODE_TAGS: 'focus-mode/tags',
  USER_STATS_DAILY_SUMMARY: 'user-stats/daily-summary',
  USER_FEEDBACK: '/user-feedback',
  USER_PROJECTS: (platform: string) => `integration/${platform}/user-projects`,
  SYNC_PROJECT: (platform: string) => `integration/${platform}/sync-project`,
  INTEGRATION_AUTH: (platform: string) => `auth/${platform.toLowerCase()}`,
  ZOHO_AUTH: 'auth/zoho',
  MONDAY_AUTH: 'auth/monday',
  JIRA_AUTH: 'auth/jira',
  ASANA_AUTH: 'auth/asana',
  TRELLO_AUTH: 'auth/trello',
  CLICK_UP_AUTH: 'auth/clickup',
  GOOGLE_AUTH: 'auth/google',
  MICROSOFT_AUTH: 'auth/microsoft',
  CALENDAR_FETCH_DATA: (platform: string) =>
    `calendar/${platform.toLowerCase()}/calendar-datas`,
  CALENDAR_UPDATE: 'calendar/calendar-update',
  CALENDAR_KEYWORD_CREATE: 'calendar/keyword-create',
  CALENDAR_KEYWORD_UPDATE: 'calendar/keyword-update',
  CALENDAR_KEYWORD_DELETE: 'calendar/keyword-delete',
  USER_LOCAL_DEVICE_SETTINGS: 'user-local-device-settings',
  SYNCED_PROJECTS_EXTERNAL_STATUS: 'synced-projects/external-statuses',
  TEAM_MANAGEMENT: 'team-management',
  TEAM_PENDING_MEMBER_ROLE: 'team-management/pending-member-role',
  TEAM_BULK_DELETE_MEMBERS: 'team-management/bulk-delete-members',
  TEAM_BULK_REMOVE_MEMBERS: 'team-management/bulk-remove-members',
  TEAM_JOIN_CODES: 'team-management/join-codes',
  TEAM_JOIN_CODES_BATCH: 'team-management/join-codes/batch',
  TEAM_CLASS_SESSION_WINDOW: 'team-management/class-session-window',
  SCHOOL_STAFF_USAGE: (teamId: string) =>
    `team-management/schools/${teamId}/staff-usage`,
  COMPLETED_ACTIVITY_LOG_QUESTION_STATS: (question_id: string) =>
    `completed-activity/log-question/${question_id}/stats`,
  TO_DO_GENERATE_SUBTASKS: 'to-do/generate-subtasks',
  ADMIN_USER_DEVICE: '/device/admin',
  ADMIN_USER_TASKS: '/to-do/admin',
  ADMIN_TRACK_EVENTS: '/admin/track-events',
  ADMIN_EXTEND_TRIAL: '/admin/subscription/extend-trial',
  ADMIN_CANCEL_SUBSCRIPTION: '/admin/subscription/cancel',
  ADMIN_UPGRADE_SUBSCRIPTION: '/admin/subscription/upgrade',
  // Focus Bear staff team administration (plan G1/G2).
  ADMIN_TEAMS: 'team-management/admin/teams',
  ADMIN_TEAM_BY_ID: (id: string) => `team-management/admin/teams/${id}`,
  USER_HABIT_PACKS: 'habit-packs/user',
  AI_CHAT: '/ai/chat',
  SYNC_TASKS: (platform: string) => `integration/${platform}/sync-tasks`,
  GET_TASKS: (platform: string, portalId: number, projectId: string) =>
    `integration/${platform}/${portalId}/projects/${projectId}/tasks`,
  UPDATE_ASSIGNEE_FILTER_STATUS: (platform: string) =>
    `integration/${platform.toLowerCase()}/assignee-filter-status`,
  ASSIGNEE_FILTER_STATUS: 'integration/assignee',
  COURSE_DETAILS: (course_id: string) =>
    `course/${encodeURIComponent(course_id)}`,
  COURSE_RATING: 'course/rating',
  LESSON_COMPLETE: 'lesson/complete',
  SYNC_PLATFORM_COURSES: 'course/sync-platform-courses',
  USER_TUTORIALS: 'course/user-tutorials',
  TO_DO_SEARCH: 'to-do/search',
  TO_DO_RECENT: 'to-do/recent',
  ACTIVITY_LIBRARY_ROUTINE_SUGGESTIONS: 'activity-library/routine-suggestions',
  ACTIVITY_LIBRARY_ROUTINE_SUGGESTIONS_ASYNC:
    'activity-library/routine-suggestions/async',
  ASYNC_TASK_BY_ID: (id: string) => `async-task/${id}`,
  HABIT_IMPORT_GENERATE_UPLOAD_URL:
    'activity-library/habits/import/generate-upload-url',
  HABIT_IMPORT_ASYNC: 'activity-library/habits/import/async',
  ENROLLED_COURSES: 'course/enrolled',
  USER_NOT_ENROLLED_COURSES: 'course/user-not-enrolled',
  COURSE_ENROLLED: 'course/enrolled',
  SURVEY: 'survey',
  ANNOUNCEMENTS: '/announcements',
  ANNOUNCEMENTS_ADMIN: '/announcements/admin',
  ANNOUNCEMENT_ADMIN_BY_ID: (id: string) => `/announcements/admin/${id}`,
  ANNOUNCEMENT_BY_ID: (id: string) => `/announcements/${id}`,
  ANNOUNCEMENT_VIEWS: (id: string) => `/announcements/admin/${id}/views`,
  TO_DO_BRAIN_DUMP: 'to-do/convert-brain-dump',
  USER_SYNCED_EXTERNAL_PLATFORMS: 'user/synced-external-platforms',
  ACCOUNT_SECURITY: 'auth/security',
  ACCOUNT_SECURITY_CHALLENGE: 'auth/security/challenge',
  ACCOUNT_SECURITY_PASSWORD: 'auth/security/change-password',
  ACCOUNT_SECURITY_MFA: 'auth/security/mfa-enrollment',
  AUTH_RESET_PASSWORD: 'auth/reset-password',
  AUTH_CHANGE_PASSWORD: 'auth/change-password',
  AUTH_SEND_EMAIL_VERIFICATION: 'auth/send-email-verification',
  AUTH_VERIFY_EMAIL: 'auth/verify-email',
  ACTIVITY_LIBRARY_ADJUST_HABITS_WITH_AI:
    'activity-library/adjust-habits-with-ai',
  USER_FOCUS_MODES: 'user/focus-modes',
  USER_DETAILS_SUMMARY: 'user/details/summary',
  ACCOUNTABILITY_BUDDY: {
    BASE: '/accountability-buddy',
    INVITE: '/accountability-buddy/invite',
    ACCEPT_INVITATION_FROM_EMAIL: '/accountability-buddy/accept-invitation',
    ACCEPT_RECEIVED_INVITATION: (id: string) =>
      `/accountability-buddy/invitations/${id}/accept`,
    REJECT_RECEIVED_INVITATION: (id: string) =>
      `/accountability-buddy/invitations/${id}/reject`,
    DELETE: (id: string) => `/accountability-buddy/${id}`,
    UNLOCK_REQUEST: '/accountability-buddy/unlock-request',
    UNLOCK_REQUESTS: '/accountability-buddy/unlock-requests',
    APPROVE_UNLOCK: (id: string) =>
      `/accountability-buddy/unlock-request/${id}/approve`,
    APPROVE_UNLOCK_BY_TOKEN: '/accountability-buddy/unlock-request/approve',
    REJECT_UNLOCK: '/accountability-buddy/unlock-request/reject'
  },
  NOTE: {
    BASE: '/note',
    TAGS: '/note/tags',
    SEARCH: '/note/search',
    FOLDERS: '/note/folders',
    IMAGES: (noteId: string) => `/note/${noteId}/images`,
    AUDIO: (noteId: string) => `/note/${noteId}/audio`,
    PDFS: (noteId: string) => `/note/${noteId}/pdfs`
  },
  /** Teacher presence auth (`presence-class-<teamId>` only; rejects private channels). */
  PUSHER_CHANNEL_AUTH: 'pusher/channel-auth',
  /**
   * Private-channel auth. Signs `private-<callerId>` from the JWT — body is
   * `{ socket_id }` only (desktop apps and CLASS TodoPlayer use this).
   */
  PUSHER_USER_AUTH: 'pusher/user-auth',
  // A7 "list-shared-for-me": team-shared focus modes visible to the caller
  // (their teams + those teams' ancestor chain). Pending backend finalisation.
  FOCUS_MODE_SHARED: 'focus-mode/shared',
  CLASS_MANAGEMENT: {
    LESSON_PLAN_PREVIEW: (teamId: string) =>
      `class-management/classes/${teamId}/lesson-plan-preview`,
    CLASSES: 'class-management/classes',
    CLASS_BY_ID: (teamId: string) => `class-management/classes/${teamId}`,
    CLASS_ARCHIVE: (teamId: string) =>
      `class-management/classes/${teamId}/archive`,
    SESSIONS: 'class-management/sessions',
    SESSION_ALLOWLIST: (sessionId: string) =>
      `class-management/sessions/${sessionId}/allowlist`,
    SESSION_TASKS: (sessionId: string) =>
      `class-management/sessions/${sessionId}/tasks`,
    SESSION_END: (sessionId: string) =>
      `class-management/sessions/${sessionId}/end`,
    RELEASE_STUDENT: (sessionId: string) =>
      `class-management/sessions/${sessionId}/release-student`,
    LIVE_SESSION: (teamId: string) =>
      `class-management/classes/${teamId}/live-session`,
    SESSION_PARTICIPANTS: (sessionId: string) =>
      `class-management/sessions/${sessionId}/participants`,
    SESSION_REPORT: (sessionId: string) =>
      `class-management/sessions/${sessionId}/report`,
    SAVE_ALLOWLIST_TO_TEMPLATE: (sessionId: string) =>
      `class-management/sessions/${sessionId}/save-allowlist-to-template`,
    SESSION_UNLOCK_REQUESTS: (sessionId: string) =>
      `class-management/sessions/${sessionId}/unlock-requests`,
    APPROVE_UNLOCK_REQUEST: (requestId: string) =>
      `class-management/unlock-requests/${requestId}/approve`,
    DENY_UNLOCK_REQUEST: (requestId: string) =>
      `class-management/unlock-requests/${requestId}/deny`,
    APPROVE_ALL_UNLOCK_REQUESTS: (sessionId: string) =>
      `class-management/sessions/${sessionId}/unlock-requests/approve-all`,
    REJECT_ALL_UNLOCK_REQUESTS: (sessionId: string) =>
      `class-management/sessions/${sessionId}/unlock-requests/reject-all`,
    CANDIDATE_MEMBERS: (teamId: string) =>
      `class-management/classes/${teamId}/candidate-members`,
    CLASS_MEMBERS: (teamId: string) =>
      `class-management/classes/${teamId}/members`,
    CLASS_MEMBER_BY_ID: (teamId: string, memberId: string) =>
      `class-management/classes/${teamId}/members/${memberId}`,
    CLASS_ATTENDANCE: (teamId: string) =>
      `class-management/classes/${teamId}/attendance`,
    CLASS_CONCERN_CRITERIA: (teamId: string) =>
      `class-management/classes/${teamId}/concern-criteria`
  },
  CLASS_SESSION: {
    INVITATIONS: 'class-session/invitations',
    CURRENT: 'class-session/current',
    JOIN: (sessionId: string) => `class-session/${sessionId}/join`,
    DECLINE: (sessionId: string) => `class-session/${sessionId}/decline`,
    LEAVE: (sessionId: string) => `class-session/${sessionId}/leave`,
    UNLOCK_REQUESTS: (sessionId: string) =>
      `class-session/${sessionId}/unlock-requests`,
    HEARTBEAT: (sessionId: string) => `class-session/${sessionId}/heartbeat`,
    COMPLETE_TASK: (sessionId: string, taskId: string) =>
      `class-session/${sessionId}/tasks/${taskId}/complete`
  },
  MCP_TOKENS: '/mcp/auth/tokens',
  MCP_TOKEN_BY_ID: (id: string) => `/mcp/auth/tokens/${id}`,
  MCP_AGENTS: '/mcp/auth/agents',
  PORTFOLIO: 'portfolio',
  PORTFOLIO_SETTINGS: 'portfolio/settings',
  PORTFOLIO_FORECAST: 'portfolio/forecast',
  DAY_PLAN_DAY: (day: string) => `day-plan/day/${day}`,
  DAY_PLAN_DISMISSED_EVENT: (day: string, eventId: string) =>
    `day-plan/day/${day}/dismissed-event/${encodeURIComponent(eventId)}`,
  DAY_PLAN_EVENT_COLOUR: 'day-plan/event-colour',
  DAY_PLAN_EVENTS: 'day-plan/events',
  DAY_PLAN_EVENTS_DAY: (day: string) => `day-plan/events/day/${day}`,
  CALENDAR_EVENTS: (platform: string) =>
    `calendar/${platform.toLowerCase()}/events`,
  DAY_PLAN_FILE_UPLOAD_URL: 'day-plan/import/file/generate-upload-url',
  DAY_PLAN_FILE_IMPORT: 'day-plan/import/file',
  DAY_PLAN_EVENT_SERIES: 'day-plan/event-series',
  DAY_PLAN_EVENT_SERIES_BY_ID: (seriesId: string) =>
    `day-plan/event-series/${encodeURIComponent(seriesId)}`,
  DAY_PLAN_EVENT_SERIES_DAY: (day: string) => `day-plan/event-series/day/${day}`,
  SUPPORT_CUSTOMER_LOOKUP: 'support/customer-lookup',
  SUPPORT_ACTION_TOKEN: 'support/action-token',
  SUPPORT_CANCEL_SUBSCRIPTION: 'support/cancel-subscription'
};

export default Endpoints;
